import {HelperFunctions} from "./helperFunctions";
import {TranslationsManager} from "../utils/localisationManager";

export const HtmlBlocks = {
    BG_OVERLAY: () => {
        const $newEl = $(`<div class="bg-overlay"></div>`);
        $newEl.on('click', ()=> { HelperFunctions.doCloseAllModalOverlays(); });
        return $newEl;
    },
    CLOSE_BTN_OVERLAY: () => {
        const $newEl = $(`<div class="close-custom-btn"></div>`);
        $newEl.on('click', ()=> { HelperFunctions.doCloseAllModalOverlays(); });
        return $newEl;
    },
    SHP_TABS_RELATED_SIMILAR: () => {
        return $(`
            <div class="shp-tabs-wrapper custom-shp">
                <div class="row">
                    <div class="col-sm-12 shp-tabs-row responsive-nav">
                        <div class="shp-tabs-holder">
                            <ul id="p-detail-tabs" class="shp-tabs p-detail-tabs visible-links" role="tablist">
                                <li class="shp-tab active">
                                    <a href="#alternativeProducts" class="shp-tab-link" role="tab" data-toggle="tab">${TranslationsManager.doGetStringByLang("SIMILAR_PRODUCTS")}</a>
                                </li>
                                <li class="shp-tab">
                                    <a href="#similarProducts" class="shp-tab-link" role="tab" data-toggle="tab">${TranslationsManager.doGetStringByLang("RELATED_PRODUCTS")}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="tab-content">
                            <div id="alternativeProducts" class="tab-pane fade in active" role="tabpanel"></div>
                            <div id="similarProducts" class="tab-pane fade" role="tabpanel"></div>
                        </div>
                    </div>
                </div>
            </div>
        `);
    }
}
